import * as Actions from '../actions';

const initialState = {
	licenseType: null,
	loading: false,
	error: null,
	valid: false
};

const keyReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_KEY: {
			return {
				...state,
				loading: false,
				error: null,
				valid: true,
				licenseType: action.payload
			};
		}
		case Actions.KEY_REQUEST: {
			return {
				...state,
				loading: true
			};
		}
		case Actions.SET_LICENSE_ERROR: {
			return {
				...state,
				error: action.payload,
				loading: false
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		default:
			return state;
	}
};

export default keyReducer;
